module.exports = __webpack_public_path__ + "static/media/totul-pentru-educatie-logo-v2.f3ca533e.png";